

window.SportLottery = {};
window.SportLottery.restrictedRegion = {
    UZ: ['CN', 'KR', 'HK'],
    GTO: ['CN', 'KR', 'HK', 'MA', 'VN', 'KG', 'BD', 'LB', 'EC', 'BO', 'NP', 'ID', 'EG', 'SA', 'MA', 'AE', 'AF', 'BH', 'DJ', 'DZ', 'IQ', 'JO', 'KM', 'KW', 'LB', 'LY', 'MR', 'OM', 'PS', 'QA', 'SD', 'SO', 'SS', 'SSD', 'SY', 'TN', 'UG', 'YE'],
    ETH: ['CN', 'KR', 'HK', 'MA', 'VN', 'KG', 'BD', 'LB', 'EC', 'BO', 'NP', 'ID', 'EG', 'SA', 'MA', 'AE', 'AF', 'BH', 'DJ', 'DZ', 'IQ', 'JO', 'KM', 'KW', 'LB', 'LY', 'MR', 'OM', 'PS', 'QA', 'SD', 'SO', 'SS', 'SSD', 'SY', 'TN', 'UG', 'YE'],
};
window.SportLottery.userInChina = true;


// WEBPACK FOOTER //
// ./src/global.js